<div
  *ngIf="control && control.invalid && control.hasError('required') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Data is Required.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('min') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value to be greater than or equal to {{ control.errors?.min.min }}.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('max') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value to be less than or equal to {{ control?.errors?.max.max }}.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('invalidEmail') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Not valid email.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('minlength') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value to be greater than or equal to the provided minimum length
    {{ control?.errors?.minlength.requiredLength }}.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('maxlength') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value to be greater than or equal to the provided minimum length
    {{ control?.errors?.maxlength.requiredLength }}.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('greaterThanZero') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value to be greater than 0.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.errors?.pattern && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Invalid input
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.errors?.futureDate && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Invalid Date
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.errors?.invalidDate && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Invalid Date
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('duplicateData') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Value already exists.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('invalidSortCode') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Invalid Sort Code.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('noneZero') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    The field value can not be 0.
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('specialCharacterError') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    {{ control?.errors?.specialCharacterError?.allowed }}
  </label>
</div>

<div
  *ngIf="control && control.invalid && control.hasError('invalidIban') && (control.touched || control.dirty)"
  class="error-msg"
>
  <label for="" class="error">
    <img alt="" src="assets/images/icon/error.png" class="error-icon" />
    Invalid IBAN.
  </label>
</div>
